import SectionLabel from "@/components/base/SectionLabel";
import { principlesData } from "@/mocks/aboutData";

export default function PrinciplesSection() {
  return (
    <section id="principles" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-8">
        <div className="reveal max-w-3xl mx-auto text-center mb-10 md:mb-14">
          <SectionLabel label={principlesData.label} className="mb-3" />
          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-900">
            {principlesData.heading}
          </h2>
        </div>

        <div className="reveal max-w-4xl mx-auto mb-10 md:mb-14">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {principlesData.items.map((item, idx) => (
              <div
                key={idx}
                className="group flex items-start gap-4 p-4 md:p-5 bg-background-100 border border-background-200/70 rounded-lg transition-colors hover:border-accent-200/60"
              >
                <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0 group-hover:bg-accent-200/60 transition-colors">
                  <i className={`${item.icon} text-base text-accent-600`} />
                </div>
                <div>
                  <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-1.5 font-heading">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Emphasis message - not in a card, larger typography */}
        <div className="reveal max-w-2xl mx-auto text-center">
          <div className="py-6 md:py-8 px-6 md:px-10">
            <p className="text-sm md:text-base text-foreground-800 font-medium leading-[2] font-heading">
              {principlesData.highlight}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}